import React from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import Dialog from "../../common/dialog";
import AppTheme from "../../AppTheme";
import ImageComponent from "../../common/ImageComponent";
import ManaButton from "../../common/ManaButton";
import appStyles from "../../../appStyles";

export default function ManaGiftDialog({
  onCancel = () => {},
  onScheduleCall = () => {},
  close = () => {},
}) {
  return (
    <Dialog.Container
      onClose={close}
      showCloseButton
      style={styles.container}
      headerStyle={{ margin: 0 }}
      contentStyle={{
        marginTop: 0,
        paddingTop: 8,
        paddingBottom: 12,
      }}
    >
      <View style={styles.header}>
        <Text style={styles.title}>A gift for you</Text>
        <Text style={styles.description}>
          As a thank you for joining us, we're offering a discounted coaching
          session to review your goals with one of our expert coaches for just
          $10 (a $70 value!)
        </Text>
      </View>

      <View
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ImageComponent
          image={require("../../../../assets/customize/gift.png")}
          style={styles.image}
        />
      </View>

      <View style={styles.buttons}>
        <ManaButton
          style={[styles.button, appStyles.buttonShadow, { marginRight: 6 }]}
          styleText={styles.buttonText}
          text="No, thanks"
          onPress={onCancel}
        />

        <ManaButton
          isMainButton
          style={styles.button}
          styleText={styles.buttonText}
          text="Claim Session"
          onPress={onScheduleCall}
        />
      </View>
    </Dialog.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
  },
  close: {
    position: "absolute",
    top: 5,
    right: 5,
  },
  header: {
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  description: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  buttons: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 8,
  },
  button: {
    width: "50%",
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
  image: {
    marginVertical: 16,
  },
});
